// =========================================================
// 設計α — order note 構造化合成 (jc-gift-note.js)
//
// PDP ギフトオプションの line item properties を真実源に、
// Shopify の order note (cart.note) を構造化合成・フル上書きする。
// これにより自由文メッセージ / のし名入れが NE 備考欄・ピッキング指示欄へ届く。
//
// 踏襲元: Dawn の cart-note カスタム要素 (assets/cart.js:278-296)
//   routes.cart_update_url + fetchConfig() + { note } の作法。
//
// 無限ループ三重対策:
//   1. 冪等化 (主軸): 生成 note と現 note が同一なら /cart/update.js を呼ばない
//   2. sections なし更新: UI 再描画の連鎖を避ける
//   3. isUpdatingNote フラグ: 自己更新中に発火した cartUpdate を無視
//
// 本番運用条件: テーマエディタの「カートメモ」を OFF にすること
//   (顧客手入力を封じ、note 全体を本 composer が所有する = 方式α-1)。
// =========================================================

(function () {
  'use strict';

  // ---- 自由文系 メッセージカードの種類 value のリスト (調査F) ----
  // data-message="true" の選択肢は現状 '父の日(自由記入)' のみ。
  // 将来増えたらここに追加するだけで判定が拡張できる。
  var FREE_TEXT_MC = ['父の日(自由記入)'];

  // ---- property キー名 (gift-option-card.liquid の name="properties[...]") ----
  var KEY_MC_TYPE = 'メッセージカードの種類';
  var KEY_MC_CONTENT = 'メッセージ内容';
  var KEY_NOSHI_NAME = 'のし名入れ';

  // ---- 全角コロン (確定仕様。NE 備考欄の表記を Avone と一致させる) ----
  var COLON = '：';

  var isUpdatingNote = false;

  function hasValue(v) {
    return typeof v === 'string' && v.trim() !== '';
  }

  // 値の取得: properties は cart.js JSON では { key: value } のオブジェクト
  function prop(item, key) {
    if (!item || !item.properties) return '';
    var v = item.properties[key];
    return (v === null || v === undefined) ? '' : String(v);
  }

  // ---- note 生成 (決定的: 同一カート → 同一文字列。冪等化の前提) ----
  function buildGiftNote(cart) {
    if (!cart || !Array.isArray(cart.items)) return '';

    var lines = [];

    cart.items.forEach(function (item) {
      var mcType = prop(item, KEY_MC_TYPE);
      var mcContent = prop(item, KEY_MC_CONTENT);
      var noshiName = prop(item, KEY_NOSHI_NAME);

      // 出力順 = 熨斗まわり(のし名入れ) → メッセージまわり(メッセージ内容) に統一
      // (PDP 入力欄・カート表示・note の3順序を揃える / A-1)。

      // のし名入れ: 非空のときのみ (Spec 1 で熨斗選択時のみ値が入る)
      if (hasValue(noshiName)) {
        lines.push(KEY_NOSHI_NAME + COLON + noshiName.trim());
      }

      // メッセージ内容: MC が自由文系 かつ 本文が非空のときのみ
      if (FREE_TEXT_MC.indexOf(mcType) !== -1 && hasValue(mcContent)) {
        lines.push(KEY_MC_CONTENT + COLON + mcContent.trim());
      }
    });

    // 重複排除 (3パーツ複製で同じ行が複数 item に出るケースを一意化)
    var seen = {};
    var unique = [];
    lines.forEach(function (line) {
      if (!seen[line]) {
        seen[line] = true;
        unique.push(line);
      }
    });

    // 出力対象ゼロなら空文字 (定型カードのみ/熨斗なし → NE 欄も空)
    return unique.join('\n');
  }

  // ---- note 書き込み (Dawn cart-note パターン踏襲、冪等化付き) ----
  function updateGiftNote(generatedNote, currentNote) {
    // 対策1: 冪等化 — 同一なら API を呼ばない (ここでループが止まる)
    var current = (currentNote === null || currentNote === undefined) ? '' : String(currentNote);
    if (generatedNote === current) return;

    if (typeof routes === 'undefined' || !routes.cart_update_url) return;

    isUpdatingNote = true; // 対策3
    var body = JSON.stringify({ note: generatedNote }); // 対策2: sections なし

    fetch(routes.cart_update_url, Object.assign({}, fetchConfig(), { body: body }))
      .then(function (response) {
        if (!response.ok) {
          console.warn('[jc-gift-note] cart update responded', response.status);
        }
      })
      .catch(function (e) {
        console.error('[jc-gift-note] note update failed', e);
      })
      .then(function () {
        isUpdatingNote = false; // 成否に関わらず必ず下ろす (フラグ立ちっぱなし防止)
      });
  }

  // ---- cart データから生成 → 冪等化付き更新 ----
  function syncFromCart(cart) {
    if (!cart) return;
    var generated = buildGiftNote(cart);
    updateGiftNote(generated, cart.note);
  }

  // ---- cartUpdate 購読 ----
  function handleCartUpdate(payload) {
    if (isUpdatingNote) return; // 対策3: 自己更新の無視

    // ★削除商品メッセージ残留バグの修正 (原因B):
    //   payload.cartData は発火元で形が異なり、カート全体の最新状態とは限らない。
    //     - ATC (product-form.js:71): /cart/add.js レスポンス = 追加した item のみ (全カートではない)
    //     - 削除/数量変更 (cart.js:218): parsedState = 全カート
    //   payload を信用すると、削除後も古い items/note を元に生成され残留が起きる。
    //   → 常に /cart.js を取得し、権威的な (削除後の) items + 現 note から
    //      完全新規生成する。これで payload の形のばらつきを根本排除する。
    fetch('/cart.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(syncFromCart)
      .catch(function (e) { console.error('[jc-gift-note] cart.js fetch failed', e); });
  }

  function init() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') {
      // pubsub 未ロード (想定外)。何もしない。
      return;
    }
    subscribe(PUB_SUB_EVENTS.cartUpdate, handleCartUpdate);

    // 初回同期: カートページを直接開いた場合の保険
    fetch('/cart.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(syncFromCart)
      .catch(function () { /* 初回は失敗しても致命的でない */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
